import { render, staticRenderFns } from "./ResultsTab.vue?vue&type=template&id=744aba5e&scoped=true"
import script from "./ResultsTab.vue?vue&type=script&lang=js"
export * from "./ResultsTab.vue?vue&type=script&lang=js"
import style0 from "./ResultsTab.vue?vue&type=style&index=0&id=744aba5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744aba5e",
  null
  
)

export default component.exports